/* globals _ */

import api from './api';

const { noop } = _;

export function save( uid, data, callback ) {
	callback = callback || noop;

	data.uid = uid;

	api( 'innoway/v2/save_user_data', data, response => {
		callback( response );
	}, 'POST' );
}

export function load( uid, callback ) {
	callback = callback || noop;

	api( 'innoway/v2/load_user_data', { uid }, response => {
		callback( response );
	}, 'POST' );
}
